import { memo, useEffect, useState } from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';
import { CRIcon, CRRender, Inline } from '../../crRender';

const timeId = Date.now()

const Field = ({ label, value = "", setValue, type, disabled, className, isRequired = true, defaultValue = "", min, step }) => {

    const { t } = useTranslation()

    const [showPassword, setShowPassword] = useState(false)
    const [inputVal, setInputVal] = useState(defaultValue || "")

    useEffect(() => {
        setValue?.({ isRequired, value: defaultValue || value?.value || "", isError: false })
        setInputVal(defaultValue)
    }, [disabled, isRequired, defaultValue])

    const handleChange = (target) => {
        const inptVal = type != 'file' ? target.value || "" : target.files
        setValue?.({
            isRequired,
            value: inptVal,
            isError: value?.isError
        })
        setInputVal(inptVal)
    }

    return (

        <div className={`form-group col-md-6  col-sm-12 ${className}`}>
            <CRRender isRender={label}>
                <label htmlFor={`${timeId}_${label}`}>{t(label)}</label>
                <Inline isRender={isRequired} className={"required"}>*</Inline>
            </CRRender >


            <input
                placeholder={`${t("please-enter")} ${t(label)}`}
                disabled={disabled}
                className={`form-control input  ${isRequired && !value?.value && value?.isError ? "field-required" : ""}`}
                type={!showPassword ? type : 'text'}
                id={`${timeId}_${label}`}
                value={inputVal || value?.value || ""}
                autoComplete="one-time-code"
                min={min}
                step={step}
                onChange={(e) => handleChange(e.target)} />

            <CRIcon
                isRender={type == "password"}
                onClick={() => setShowPassword(prev => !prev)}
                icon={`fa:eye${!showPassword ? "" : "-slash"}`}
                className={'eye-sign'} />
        </div>
    )
}
export default memo(Field);